// Libs
import classNames from 'classnames'
import React, { Component } from 'react'
import { Send } from 'react-feather'
import { Col, Row } from '../../../../components/Elemental'

// CSS
import './styles.scss'

// Components/Containers
import ProfileIcon from '../../../../components/ProfileIcon'
import UpDownIcon from '../../../../components/UpDownIcon'
import Mediator from '../../../Mediator'

// Constants
import { secureData } from '../../../../constants/others'

class SpCasePageMessages extends Component {
  state = {
    input: {
      id: '',
      visible: false,
      value: '',
      focus: false
    },
    type: '',
    clicked: '',
    hasDocument: false,
    hasSignedDocument: false,
    documentErrorMessage: null
  }

  UNSAFE_componentWillMount(nextProps) {
    const { spCase: { chat } } = this.props
    const { secureChat } = this

    secureChat(chat)

    // If there's any document sended previously
    let signed = false
    let minute = false
    chat.map(item => {
      if (item.minutaId) {
        if (item.createBy === 'lawyer') {
          signed = true
          minute = true
        }
        else {
          minute = true
        }
      }
    })
    this.setState({ ...this.state, hasSignedDocument: signed, hasDocument: minute })
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { spCase: { chat } } = this.props
    const nextChat = nextProps.spCase.chat
    const { secureChat } = this

    if (chat.length !== nextChat.length) {
      secureChat(nextChat)
      this.setState({ ...this.state, input: { ...this.input, id: '' } })
      let signed = false
      let minute = false
      // If there's any document sended previously
      nextChat.map(item => {
        if (item.minutaId) {
          if (item.createBy === 'lawyer') {
            signed = true
            minute = true
          }
          else {
            minute = true
          }
        }
      })
      this.setState({ ...this.state, hasSignedDocument: signed, hasDocument: minute })
    }
  }

  secureChat = (chat) => {
    return chat.map(message => {
      // If there's a text
      if (message.text) {
        // Secure email
        let re = /([a-zA-Z0-9._-]+@(?!semprocesso)[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/gi
        message.text = message.text.replace(re, x => {
          return secureData(x)
        })

        // Secure telefone
        re = /\(([1-9][0-9])\)\s?((?:9\d|[2-9])\d{3})\-?(\d{4})/g
        message.text = message.text.replace(re, x => {
          return secureData(x)
        })
      }
    })
  }

  inputArea = (message) => {
    const { user: { role }, spCase: { company, lawyer }, handleNew, handleUpload } = this.props
    const { textarea } = this.refs
    const { input } = this.state
    const placeholder = message.status === 3 ? "Escreva aqui sua mensagem" : "Escreva aqui sua nova proposta."

    return (
      <div
        className={input.visible && input.id === message.id && message.allowed === role ?
          "sp-case-page-messages__input sp-case-page-messages__input--visible" :
          "sp-case-page-messages__input"}>
        <div className={(input.focus || (input.value && input.value !== '')) ?
          "sp-case-page-messages__textarea sp-case-page-messages__textarea--focus" :
          "sp-case-page-messages__textarea"}>
          <textarea
            ref={(input) => { this.inputRef = input }}
            placeholder={placeholder}
            onChange={e => this.setState({ input: { ...input, value: e.target.value } })}
            onFocus={() => this.setState({ input: { ...input, focus: true } })}
            onBlur={e => {
              this.setState({ input: { ...input, focus: false } })
              e.target.scrollTop = 0
            }} />
          {/* <Tools
            onClick={() => console.log('oi')}
            visible={input.focus} /> */}
        </div>
        <div
          className="sp-case-page-messages__send"
          onClick={e => input.value && handleNew(input.value, lawyer, company, message.status)}>
          <p>Enviar</p>
          <span><Send size="20" /></span>
        </div>
      </div>
    )
  }

  inputVisible = (inputId) => {
    this.inputRef.focus()

    this.setState({ input: { id: inputId, visible: true, focus: true } })
  }

  createSystemClassName = (message) => {
    const { clicked } = this.state
    const accept = ((message.status === 3 && (message.subStatus === 1 || message.subStatus === 4)) || (message.status === 999 && message.subStatus === 1))
    const unarchived = (message.subStatus === 5)

    return classNames(
      'sp-case-page-messages__card',
      {
        'sp-case-page-messages__card--system-accept': accept && !unarchived,
        'sp-case-page-messages__card--system-decline': !accept && !unarchived,
        'sp-case-page-messages__card--system-clicked': clicked === message.id && !unarchived,
        'sp-case-page-messages__card--system-unarchived': unarchived
      }
    )
  }

  createClassName = (message) => {
    const { clicked } = this.state
    const { user: { role } } = this.props
    const sent = (message.createBy === role)

    return classNames(
      'sp-case-page-messages__card',
      `sp-case-page-messages__card--status-${message.status}`,
      {
        'sp-case-page-messages__card--sent': sent,
        'sp-case-page-messages__card--received': !sent,
        'sp-case-page-messages__card--clicked': clicked === message.id
      }
    )
  }

  UpDownArea = (message, file, text, fileId = null) => {
    const { download, spCase: { id }, handleDownload } = this.props

    return (
      <div
        className="sp-case-page-messages__download"
        onClick={(e) => {
          e.stopPropagation();
          if (download.progress === 0 || download.progress >= download.total) {
            handleDownload(file, fileId)
          }
        }}>
        <div className="sp-case-page-messages__download-info">
          <p>
            {
              download.err ?
                'Arquivo corrompido' :
                download.progress === 0 || download.progress >= download.total ?
                  `Clique para baixar ${file}` :
                  download.spCaseId === id &&
                    download.fileRequest === file &&
                    download.fileId === fileId ?
                    'Baixando arquivo(s)...' :
                    `Clique para baixar ${file}`
            }
          </p>
          <p>{text}</p>
        </div>
        <UpDownIcon
          err={download.err}
          type="download"
          progress={
            download.spCaseId === id &&
              download.fileRequest === file &&
              download.fileId === fileId ?
              download.progress >= download.total ?
                download.total / download.total :
                download.progress / download.total :
              0}>
          ZIP
        </UpDownIcon>
      </div>
    )
  }

  unarchivevdMessageFields = (status, role, checkout, message, lawyer, company) => {
    const { hasDocument, hasSignedDocument } = this.state
    const {
      handleStart,
      handleAccept,
      handleDecline,
      handleCheckout } = this.props

    if (status === 1) {
      return (
        <ul className="sp-case-page-messages__actions">
          <li onClick={handleStart}>Negociar</li>
          <li onClick={e => handleDecline(message, lawyer, company)}>Recusar</li>
        </ul>
      )
    }

    if (status === 2) {
      return (
        <ul className="sp-case-page-messages__actions">
          <li onClick={e => handleAccept(message, lawyer, company)}>Aceitar</li>
          <li onClick={e => this.inputVisible(message.id)}>Enviar Contraproposta</li>
        </ul>)
    }

    if (status === 3 && role === 'company' && checkout) {
      return (
        <ul className="sp-case-page-messages__actions">
          <li onClick={() => {
            this.setState({ type: 'minuta' })
            this.uploadFile.click()
          }}>Anexar Minuta</li>
          <li onClick={e => this.inputVisible(message.id)}>Enviar Mensagem</li>
          {hasSignedDocument &&
            <li onClick={() => {
              this.setState({ type: 'protocolo' })
              this.uploadFile.click()
            }}>Anexar Protocolo</li>}
        </ul>
      )
    }

    if (status === 3 && role === 'company' && !checkout) {
      return (
        <ul className="sp-case-page-messages__actions">
          <li onClick={() => handleCheckout()}>Inserir os Termos do Acordo</li>
        </ul>
      )
    }

    if (status === 3 && role === 'lawyer') {
      return (
        <ul className="sp-case-page-messages__actions">
          {(hasDocument || hasSignedDocument) &&
            <li onClick={() => {
              this.setState({ type: 'minuta' })
              this.uploadFile.click()
            }}>Anexar Minuta Assinada</li>}
          <li onClick={e => this.inputVisible(message.id)}>Enviar Mensagem</li>
        </ul>
      )
    }
  }

  filterChat = (chat) => {
    const ids = chat.map(o => o.id)
    const filtered = chat.filter(({ id }, index) => !ids.includes(id, index + 1))
    return filtered
  }

  render() {
    const {
      user: {
        role,
        token,
        admin
      },
      spCase: {
        lawsuitNumber,
        company,
        lawyer,
        group,
        inicial,
        anexos,
        chat,
        origin,
        status,
        viewedOppositePart
      },
      checkout,
      handleUpload,
      handleStart,
      handleAccept,
      handleDecline,
      handleCheckout,
      handleFinish,
      handleClickSign,
      handlePrint,
      handleUnarchive,
      validateFile,
      validateFileError
    } = this.props
    const { input, type, clicked, hasDocument, hasSignedDocument } = this.state
    return (
      <div className="sp-case-page-messages">
        <input
          hidden
          type="file"
          accept="application/pdf"
          onChange={(evt) => {
            const file = evt.target.files[0]
            const { isValid, message } = validateFile(file)
            //TODO: change this
            // console.log(file, message)
            if (!isValid) {
              validateFileError(message)
            }

            if (isValid) handleUpload(type, this.uploadFile.files)
            setTimeout(() => this.uploadFile.value = '', 500)
          }}
          ref={input => this.uploadFile = input} />
        {this.filterChat(chat).map((message, idx) => {
          return (
            <Row
              key={message.id}
              className={
                message.createBy === role ?
                  "sp-case-page-messages__wrapper sp-case-page-messages__wrapper--sent" :
                  "sp-case-page-messages__wrapper sp-case-page-messages__wrapper--received"
              }>
              {role === 'lawyer' && message.createBy === role && (chat.length === idx + 1) &&
                <Col xs="100%" md="100%" lg="40%">
                  <Mediator />
                </Col>
              }
              {/* If is created by a lawyer or a company */}
              {(message.createBy === 'lawyer' || message.createBy === 'company') &&
                <Col xs="90%" md="75%" lg="60%">
                  <div
                    onClick={() => {
                      if (chat[chat.length - 1].id !== message.id) {
                        this.setState({ clicked: clicked === message.id ? '' : message.id })
                      }
                    }}
                    className={this.createClassName(message)}>
                    {message.createBy !== role &&
                      <div className="sp-case-page-messages__header">
                        <p>{
                          message.createBy === 'lawyer' ?
                            `${lawyer.name} ${lawyer.surname.split(' ', 1)[0]}` :
                            `${company.fantasyName}`}</p>
                      </div>
                    }
                    {!message.minutaId &&
                      <p className="sp-case-page-messages__message">
                        {message.text}
                      </p>
                    }
                    {message.minutaId &&
                      <p className="sp-case-page-messages__message">
                        {message.text}
                      </p>
                    }
                    {/* If there`s inicial */}
                    <Row className="sp-case-page-messages__downloads">
                      {message.status === 1 && inicial &&
                        <Col md="350px">
                          {this.UpDownArea(message, 'inicial', 'Inicial em formato .pdf')}
                        </Col>
                      }
                      {message.status === 1 && anexos &&
                        <Col md="350px">
                          {this.UpDownArea(message, 'anexos', 'Anexos em formato .zip')}
                        </Col>
                      }
                      {message.minutaId &&
                        <Col md="350px">
                          {this.UpDownArea(message, 'minuta', 'Minuta em formato .pdf', message.minutaId)}
                        </Col>
                      }
                    </Row>
                    {/* If status is 1 and role is allowed */}
                    {message.status === 1 && role === message.allowed &&
                      <ul className="sp-case-page-messages__actions">
                        <li onClick={handleStart}>Negociar</li>
                        <li onClick={e => handleDecline(message, lawyer, company)}>Recusar</li>
                      </ul>
                    }
                    {/* If status is 2 and subStatus is 0 and role is allowed */}
                    {message.status === 2 && message.subStatus === 1 && role === message.allowed &&
                      <ul className="sp-case-page-messages__actions">
                        <li onClick={e => this.inputVisible(message.id)}>Enviar Proposta</li>
                      </ul>
                    }
                    {/* TODO: Transform company.name into a variable that decide if the lawyer or the company will send the proposal first */}
                    {/* If status is 2 and subStatus is 1 and role is allowed */}
                    {message.status === 2 && message.subStatus === 2 && role === message.allowed && !(message.id == 2 && origin === 'company' && company.cnpj == '08.560.999/0001-35') &&
                      <ul className="sp-case-page-messages__actions">
                        <li onClick={e => handleAccept(message, lawyer, company)}>Aceitar</li>
                        <li onClick={e => this.inputVisible(message.id)}>Enviar Contraproposta</li>
                        <li onClick={e => handleDecline(message, lawyer, company)}>Encerrar</li>
                      </ul>
                    }
                    {message.status === 2 && message.subStatus === 2 && role === message.allowed && message.id == 2 && origin === 'company' && company.cnpj === '08.560.999/0001-35' &&
                      <ul className="sp-case-page-messages__actions">
                        <li onClick={e => this.setState({ input: { id: message.id, visible: true } })}>Enviar Proposta</li>
                      </ul>
                    }
                    {/* If status is 3 and subStatus is 1 and role is company and role is allowed */}
                    {message.status === 3 && message.subStatus === 2 && role === 'company' && message.allowed === role && !hasSignedDocument && (
                      <ul className="sp-case-page-messages__actions">
                        <li onClick={() => {
                          this.setState({ type: 'minuta' })
                          this.uploadFile.click()
                        }}>Anexar Minuta</li>
                        <li onClick={() => this.setState({ input: { id: message.id, visible: true } })}>Enviar Mensagem</li>
                      </ul>
                    )}
                    {message.status === 3 && message.subStatus === 2 && role === 'company' && message.allowed === role && hasSignedDocument && (
                      <ul className="sp-case-page-messages__actions">
                        <li onClick={() => {
                          this.setState({ type: 'minuta' })
                          this.uploadFile.click()
                        }}>Anexar Minuta</li>
                        <li onClick={e => this.inputVisible(message.id)}>Enviar Mensagem</li>
                        <li onClick={() => {
                          this.setState({ type: 'protocolo' })
                          this.uploadFile.click()
                        }}>Anexar Protocolo</li>
                      </ul>
                    )}
                    {/* If status is 3 and subStatus is 2 or 3 and role is lawyer and role is allowed */}
                    {message.status === 3 && (message.subStatus === 2 || message.subStatus === 3) && role === 'lawyer' && role === message.allowed &&
                      <ul className="sp-case-page-messages__actions">
                        {(hasDocument || hasSignedDocument) &&
                          <li onClick={() => {
                            this.setState({ type: 'minuta' })
                            this.uploadFile.click()
                          }}>Anexar Minuta Assinada</li>
                        }
                        <li onClick={() => this.inputVisible(message.id)}>Enviar Mensagem</li>
                      </ul>
                    }
                    {/* If status is 3 and subStatus is 4 and role is company and role is allowed */}
                    {message.status === 3 && message.subStatus === 4 && role === 'company' && role === message.allowed &&
                      <ul className="sp-case-page-messages__actions">
                        <li onClick={() => {
                          this.setState({ type: 'minuta' })
                          this.uploadFile.click()
                        }}>Anexar Minuta</li>
                        <li onClick={e => this.inputVisible(message.id)}>Enviar Mensagem</li>
                        <li onClick={() => {
                          this.setState({ type: 'protocolo' })
                          this.uploadFile.click()
                        }}>Anexar Protocolo</li>
                      </ul>
                    }
                    {(clicked === message.id || chat[chat.length - 1].id === message.id) &&
                      <div className={input.id !== message.id ?
                        "sp-case-page-messages__datetime sp-case-page-messages__datetime--visible" :
                        "sp-case-page-messages__datetime"}>
                        {role === 'company' &&
                          message.userAdmin != 1 &&
                          message.userName &&
                          message.userSurname &&
                          <span>
                            <ProfileIcon
                              width={20}
                              fontSize={8}
                              marginRight={5}
                              image={`https://server.semprocesso.com.br/user/image/${token}/${message.userId}/0/small`}
                              lawyerName={message.userRole == 1 ? `${message.userName} ${message.userSurname}` : null}
                              companyName={message.userRole == 2 ? `${message.userName} ${message.userSurname}` : null} />
                            {`${message.userName.trim()} ${message.userSurname.trim()}, `}
                          </span>
                        }
                        {`${message.date} - ${message.hour}`}
                        {(role === 'company' && viewedOppositePart && admin && idx === chat.length - 1 && message.createBy === 'company') ? ", Visualizado" : ""}
                      </div>
                    }
                  </div>
                  {this.inputArea(message)}
                </Col>
              }
              {/* If is created by the system */}
              {message.createBy === 'system' &&
                <Col>
                  <div
                    onClick={() => {
                      if (chat[chat.length - 1].id !== message.id) {
                        this.setState({ clicked: clicked === message.id ? '' : message.id })
                      }
                    }}
                    className={this.createSystemClassName(message)}>
                    <div className="sp-case-page-messages__header">
                      <p>Com Acordo</p>
                    </div>
                    <p className="sp-case-page-messages__message">{message.text}</p>
                    <Row className="sp-case-page-messages__downloads">
                      {message.minutaId &&
                        <Col md="350px">
                          {this.UpDownArea(message, 'minuta', 'Minuta em formato .pdf', message.minutaId)}
                        </Col>
                      }
                      {message.protocoloId &&
                        <Col md="350px">
                          {this.UpDownArea(message, 'protocolo', 'Protocolo em formato .pdf', message.protocoloId)}
                        </Col>
                      }
                    </Row>
                    {/* If status is 3 and subStatus is 1 and role is company and role is allowed and checkout is true */}
                    {message.status === 3 && message.subStatus === 1 && role === 'company' && role === message.allowed && checkout &&
                      <ul className="sp-case-page-messages__actions">
                        <li onClick={() => {
                          this.setState({ type: 'minuta' })
                          this.uploadFile.click()
                        }}>Anexar Minuta</li>
                        <li onClick={() => this.inputVisible(message.id)}>Enviar Mensagem</li>
                      </ul>
                    }
                    {/* If status is 3 and subStatus is 1 and role is company and role is allowed and checkout is false */}
                    {message.status === 3 && message.subStatus === 1 && role === 'company' && role === message.allowed && !checkout &&
                      <ul className="sp-case-page-messages__actions">
                        <li onClick={() => handleCheckout()}>Inserir os Termos do Acordo</li>
                      </ul>
                    }
                    {role === message.allowed && message.subStatus === 5 && (
                      this.unarchivevdMessageFields(status, role, checkout, message, lawyer, company)
                    )}
                    {/* If status is 999 and subStatus is 2 and role is company */}
                    {'none' === message.allowed && status === 999 && message.status === 999 && (message.subStatus === 2 || message.subStatus === 0) && (
                      <ul className="sp-case-page-messages__actions">
                        {role === 'company' && <li onClick={handlePrint}>Visualizar Certificado</li>}
                        {origin === 'company' && <li onClick={handleUnarchive}>Desarquivar</li>}
                      </ul>
                    )}
                    {/* message.status === 3 && message.subStatus === 4 && message.clicksignId &&
                      <ul className="sp-case-page-messages__actions">
                        <li onClick={() => handleClickSign(message.clicksignId)}>Assinar Minuta</li>
                      </ul> */}
                    {(clicked === message.id || chat[chat.length - 1].id === message.id) &&
                      <div className={input.id !== message.id ?
                        "sp-case-page-messages__datetime sp-case-page-messages__datetime--visible" :
                        "sp-case-page-messages__datetime"}>
                        {`${message.date} - ${message.hour}`}
                      </div>
                    }
                  </div>
                  {this.inputArea(message)}
                </Col>
              }
            </Row>
          )
        })}
      </div>
    )
  }
}

export default SpCasePageMessages
